import { render, staticRenderFns } from "./ElementsTreeNodeSettingsDialog.vue?vue&type=template&id=64e3c587"
import script from "./ElementsTreeNodeSettingsDialog.vue?vue&type=script&lang=js"
export * from "./ElementsTreeNodeSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./ElementsTreeNodeSettingsDialog.vue?vue&type=style&index=0&id=64e3c587&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports